<template>
  <div class="t9_selpro">
    <div class="section_projects">
      <div
        v-for="(project,projectIndex) in projectList"
        v-if="project.extinfo&&project.extinfo.buildingBanner"
      >
        <div class="projects" @click="tapProject(project)">
          <div class="projects_name">{{project.extinfo.buildingName}}</div>
          <div class="op">
            <img src="https://assets.rurushishi.com//yq-rs-make/t9_zxrg/arrow_2.png" alt />
          </div>
        </div>
      </div>

      <div class="noData" v-if="showNoData">未找到相关配置项目</div>
    </div>
    <!-- lj25 -->
    <BtnBackLayout4></BtnBackLayout4>
  </div>
</template>

<script>
import util from "@/utils/utils";
import { mapState, mapMutations } from "vuex";
import * as comreq from "@/utils/comreq";
import Cookies from "js-cookie";
const BtnBackLayout4 = () => import("@/components/btn_back_layout4");
export default {
  components: {
    BtnBackLayout4
  },
  props: {},
  data() {
    return {
      projectList: [],
      showNoData: false,
      isSale: false,
    };
  },
  watch: {},
  computed: {
    ...mapState([
      "isShowGuide",
      "isInMiniProgram",
      "receiveSpreadInfo",
      "shareSpreadInfo",
      "pageInfo",
      "userInfo"
    ])
  },
  methods: {
    
    tapProject(item) {
      let that = this
      let url = ''
      if(that.isSale) {
        //顾问
        if(item.roleid && item.roleid > 2011) {
          url = `${location.protocol}//${location.host}/h5/huafasubscription/orderpage?pid=${item.pid}&managerId=1`;
        } else {
          url = `${location.protocol}//${location.host}/h5/huafasubscription/orderpage?pid=${item.pid}`;
        }
      } else {
        url = `${location.protocol}//${location.host}/h5/huafasubscription/myPayPage?pid=${item.pid}`;
      }
      util.openYqRsMakeLink(url);
    }, 

    setProjectList(list) {
      let that = this 
      if (that.pageInfo.Extinfo.content_pagetags) {
        let pagetagsObj = {
          // channel: null,
          // banner: null,
          // 热点新闻: null,
          // 精选项目: null
        };
        pagetagsObj.channel = {
          pagetags: that.pageInfo.Extinfo.content_channel_tags,
          tagname: that.pageInfo.Extinfo.content_channel_tags_name
        };
        that.pageInfo.Extinfo.content_pagetags.forEach(item => {
          pagetagsObj[item.section] = item;
        });

        comreq
          .listPageInfoWithChannel2(
            pagetagsObj.channel.pagetags,
            pagetagsObj["精选项目"].pagetags
          )
          .then(data => {
            if (data && data.list) {
              data.list = data.list.map(item => {
                if (item.extinfo) {
                  item.extinfo = JSON.parse(item.extinfo);
                }
                return item;
              });
              //判断是否开启在线认筹
              data.list = data.list.filter(item => {
                if (
                  item.extinfo.actConfig &&
                  item.extinfo.actConfig.open_getonline == 1 &&
                  item.extinfo.actConfig.getonline_banner_img
                ) {
                  return true;
                }
                return false;
              });

              //如果list有值则比对里面的项目
              if(list) {
                let tmp = []
                data.list.forEach(e => {
                  list.forEach(o => {
                    if(parseInt(e.pid) == o.projectid) {
                      e.roleid = o.roleid
                      tmp.push(e)
                    }
                  })
                })
                that.projectList = tmp;
              } else {
                that.projectList = data.list;
              }
              if(that.projectList <= 0) {
                that.showNoData = true
              }
            } else {
              that.showNoData = true
            }
            console.log("精选项目", JSON.parse(JSON.stringify(data)));
          });
      }
    }
  },
  created() {
    util.checkMapStateCallback(this, ["pageInfo","userInfo"]).then(() => {
      // 是否注册过
      comreq.getUserIntegralInfo().then(userInfo => {
        if (userInfo.isSale == true) {
          this.isSale = true
          //获取有权限的项目列表
          comreq.listAssignedProjects(Cookies.get("openid")).then(res => {
            if(res.obj && res.obj.length > 0) {
              this.setProjectList(res.obj)
            }
          })
        } else {
          this.setProjectList()
        }
      });

    });
  },
  mounted() {}
};
</script>
<style lang="css" scoped>
/* 精选项目 */
.section_projects {
  width: 100%;
  padding-bottom: 20px;
}

.projects {
  width: 90%;
  padding: 20px 0;
  margin-left: 5%;
  border-bottom: 1px solid #f7f7f7;
  display: flex;
  justify-content: space-between;
}
.projects .op img {
  width: 20px;
  height: 20px;
}
.noData {
  line-height: 1rem;
  text-align: center;
}
</style>